<template>
  <div class="chart-container">
    <div class="chart-main-container">
      <chart ref="chart" chartType="bar" chartId="AcfChart" :width="836" :height="size === 'mini' ? 300 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import ChartCmp from './base.vue'
import CommonUtil from '../../utils/common'
import { GraphBarColorSet } from '../../defines/chart-color'
import { FigurePreviewAcf, FigurePreviewAcfResult } from '../../defines/model/figure'

export default {
  name: 'AcfChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    acf: FigurePreviewAcf,
    selectedType: '',
    selectedColumnIndex: {type: Number, default: 0},
    size: '',
    visible: Boolean
  },
  data () {
    return {
      selectedAcfResult: FigurePreviewAcfResult
    }
  },
  created () {
    this.selectedAcfResult = this.acf.results[this.selectedColumnIndex]
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (!this.visible) return
      if (newIndex < 0) return
      this.selectedAcfResult = this.acf.results[newIndex]
    },
    selectedAcfResult (acfResult) {
      if (CommonUtil.isEmpty(acfResult)) return

      const lag = acfResult.value.map(value => value.lag)
      const value = acfResult.value.map(value => value.value)
      const isMini = (this.size === 'mini')

      let datasets = [
        Object.assign(
          {
            data: value,
            type: 'bar',
            yAxisID: 'value',
            fill: false,
            lineTension: 0,
            pointBorderWidth: isMini ? 4 : 8
          },
          GraphBarColorSet.blue
        )
      ]

      const chartData = {
        labels: lag,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'value',
              position: 'left',
              scaleLabel: {
                display: false
              },
              ticks: {
                beginAtZero: false,
                major: {},
                minor: {}
              }
            }
          ],
          xAxes: [
            {
              display: false,
              ticks: {
                beginAtZero: false,
                major: {},
                minor: {}
              }
            }
          ]
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}
</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/acf.vue